export default {
  'New layer': 'Nuovo livello',
  "Elements on layer {0}": "Elementi nel livello {0}",
  "Layers": "Livelli",
  "Project config": "Configurazione progetto",
  "width": "Larghezza",
  "height": "Altezza",
  "Cancel": "Annulla",
  "Save" : "Salva",
  "Layer config": "Configurazione livello",
  "Name" : "Nome",
  "opacity": "Opacità",
  "altitude": "Quota",
  "order":"Ordine",
  "Delete": "Elimina",
  "New project": "Nuovo progetto",
  "Save project": "Salva progetto",
  "Load project": "Carica progetto",
  "3D View": "Vista 3D",
  "2D View": "Vista 2D",
  "3D First Person": "3D Prima persona",
  "Zoom in": "Ingrandisci",
  "Zoom out": "Riduci",
  "Pan": "Muovi",
  "Undo (CTRL-Z)": "Annulla (CTRL-Z)",
  "Configure project": "Configura progetto",
  "Open catalog": "Apri catalogo",
  "Reset": "Annulla",
  "Unselect": "Deseleziona",
  "Configure layer": "Configura livello",
  "Delete layer": "Elimina livello",
  "Properties: [{0}] {1}": "Proprietà: [{0}] {1}",
  "Get Screenshot" : "Cattura uno screenshot",
  "Catalog" : "Catalogo",
  "Rotation" : "Rotazione",
  "Altitude": "Quota",
  "Would you want to start a new Project?": "Vuoi iniziare un nuovo progetto?",
  "Copy":"Copia",
  "Paste":"Incolla",
  "Search Element":"Cerca Elemento",
  "Last Selected":"Ultimi Selezionati",
  "Length":"Lunghezza",
  "Lines":"Linee",
  "Holes":"Buchi",
  "Items":"Oggetti",
  "Areas":"Aree",
  "Snap to Point":"Snap al Punto",
  "Snap to Line":"Snap alla Linea",
  "Snap to Segment":"Snap al Segmento",
  "Snap to Grid":"Snap alla Griglia",
  "Mouse X Coordinate":"Coordinata X del Mouse",
  "Mouse Y Coordinate":"Coordinata Y del Mouse",
  "Scene Zoom Level":"Livello di Zoom della Scena"
}



// WEBPACK FOOTER //
// ./src/translator/it.js